var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Mock API for user-related operations
 */
import { DEFAULT_USER_SETTINGS } from '@/api/constants';
export const mockUser = {
    id: 1,
    username: 'mockUser',
    email: 'mockUser@example.com',
    firstName: 'Mock',
    lastName: 'User',
    isSuperuser: false,
    isStaff: false,
    groups: [],
};
export const mockUserApi = {
    getUser: () => __awaiter(void 0, void 0, void 0, function* () {
        const mock = localStorage.getItem('mockUser');
        if (mock)
            return JSON.parse(mock);
        return new Promise((resolve) => setTimeout(() => resolve(mockUser), 300));
    }),
    getUserSettings: () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve(DEFAULT_USER_SETTINGS), 300));
    }),
    updateUserSettings: (settings) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve(settings), 300));
    }),
};
